import { RootState } from "../Store";

export const SELECT_APPLICATIONS = (state: RootState) =>
  state.applicationBankListSlice.applicationBanks;
//applications
// filter
// last_page
// typeBG

export const SELECT_APPLICATIONS_TYPE_BG = (state: RootState) =>
  state.applicationBankListSlice.typeBG;

// export const SELECT_APPLICATIONS_START_INDEX = (state: RootState) =>
//   state.applicationsAllSlice.startIndex;

export const SELECT_APPLICATIONS_LAST_PAGE = (state: RootState) =>
  state.applicationBankListSlice.last_page;

// export const SELECT_APPLICATIONS_SCROLL = (state: RootState) =>
//   state.applicationsAllSlice.scrollPosition;

// export const SELECT_IS_NEW_MESSAGE = (id: number) => (state: RootState) => {
//   const application = state.applicationsAllSlice.applicationBanks.find(
//     (app) => app.id === id
//   );
//
//   // return application?.isNewMessage || false;
// };

export const SELECT_FILTER = (state: RootState) =>
  state.applicationBankListSlice.filter;
